'use client';

import clsx from 'clsx';
import { useFormatter, useTranslations } from 'next-intl';
import { useCurrency } from '@/hooks/useCurrency';

export type PriceProps = {
  children: number;
  format?: 'default' | 'from';
  className?: string;
};

export const Price = ({ children: price, format = 'default', className }: PriceProps) => {
  const t = useTranslations('general');
  const { data: currency } = useCurrency();
  const formatter = useFormatter();
  const formattedPrice = formatter.number(price, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const displayPrice =
    format === 'from' ? t('priceFrom', { price: formattedPrice }) : formattedPrice;

  return <span className={clsx(className)}>{displayPrice}</span>;
};
